import React from 'react'
import DynamicFormElements from '../Form/DynamicFormElements'

const formConfigTemplate = [
    {
        type: 'select',
        name: 'storeHouseId',
        //label: 'warehouse',
        label: 'usePrimaryWarehouse',
        defaultIsEmptyGuid: true,
        defaultOptionIsSelectable: true,
        defaultName: 'select',
        options: []
    },
    {
        type: 'checkbox',
        name: 'checkImportDataOnly',
        label: 'checkImportDataOnly'
    },
    {
        type: 'text',
        name: 'mailAddress',
        label: 'emailAddress'
    },

]

const ArticleImport = ({ formData, setFormData, formErrors }) => {

    return (
        <>
            <DynamicFormElements formConfigTemplate={formConfigTemplate} setFormData={setFormData} formData={formData} formErrors={formErrors} />
        </>
    )
}
export default ArticleImport